module.exports = __webpack_public_path__ + "img/ico-linux.9c4e063.svg";